module.exports = __webpack_public_path__ + "img/album17_05.06acd4c3.jpg";